<template>
  <div class="footer-stylist-container jm-px-5 jm-py-6">
    <div class="footer-stylist-content jm-bg-white jm-p-3">
      <p class="footer-stylist-text jm-text-center jm-mt-0" v-html="text"></p>

      <div v-if="labelButton" class="jm-pb-3">
        <a :href="url" class="jm-text-decoration-none" target="_blank">
          <BaseButton
            data-test="set-date-btn"
            @click="redirectToConfirmation(stylist)"
            class="jm-font-bold jm-uppercase"
            >{{ labelButton }}</BaseButton
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/molecules/BaseButton.vue'

const WEBINAR_URL =
  'https://app.livestorm.co/beauty-blend/devenir-styliste-beaute-jolimoi?type=light'

export default {
  name: 'FooterStylist',
  components: { BaseButton },
  props: {
    text: {
      type: String,
      default: ''
    },
    labelButton: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      url: WEBINAR_URL
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-stylist-container {
  background-image: url('../../assets/images/background-footer.png');
  background-repeat: no-repeat;
  background-position: bottom;
}

.footer-stylist-text {
  font-size: $font-size-l;
  line-height: 1.5em;
}
</style>
